var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-overlay",class:_vm.backgroundOverlayClass},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"})])}
var staticRenderFns = []

export { render, staticRenderFns }